import { FeatureListItem, XaiMonospaceFeatureText, DirectionalityFeatureTypeText } from '../Styled';
import { XAILikelyTileFeatureListItemTypes } from './types';
import { XAI_LIKELY_FEATURE_TYPES_TEXT } from './constants';
import { XaiMonospaceTextTooltipWrapper } from './XaiMonospaceTextTooltipWrapper';
import { FeatureType } from '../../types';
import { TEST_IDS } from '../../constants';

export const XAILikelyTileFeatureListItem = ({ feature }: XAILikelyTileFeatureListItemTypes) => {
  const { name, featureType } = feature;
  const featureTypeTextLength = featureType === FeatureType.PURCHASEEVENT ? '190' : '200';
  return (
    <FeatureListItem>
      <XaiMonospaceTextTooltipWrapper name={name} $textMaxWidth={featureTypeTextLength}>
        <XaiMonospaceFeatureText data-test={`${TEST_IDS.XAITopThreeFeatures}_${name}`}>
          {name}
        </XaiMonospaceFeatureText>
      </XaiMonospaceTextTooltipWrapper>
      <DirectionalityFeatureTypeText>
        {XAI_LIKELY_FEATURE_TYPES_TEXT[featureType]}
      </DirectionalityFeatureTypeText>
    </FeatureListItem>
  );
};
